function EscalationPlanCardView() {
    "use strict";

    this.EscalationPlanId = -1;
    this.OrganizationId = -1;
    this.Name = '';
    this.OrganizationName = '';

    this.Plan = null;
    this.Organization = null;
}
if (typeof exports !== 'undefined') {
    module.exports = EscalationPlanCardView;
}